import React, { useContext } from "react";
import MenuButton from "../MenuButton/MenuButton";
import { NoteState } from "../../context/notes/NoteState";
import ClientAssessmentsPanel from "../ClientAssesment/ClientAssessmentsPanel";

export default function PhysioAssessments() {
  const { state } = useContext(NoteState);
  const { branch_id } = state;

  return (
    <div className="site-main-design">
      <MenuButton />
      <div className="container-fluid pb-4">
        <div className="page-heading mb-3">
          <h3>
            <i className="bi bi-clipboard2-pulse me-2"></i>Assessments
          </h3>
          <p className="text-muted mb-0">
            Post assessments recorded by GT and PT. Add, view, and download from here.
          </p>
        </div>
        <ClientAssessmentsPanel branchId={branch_id} inputId="physio-assess-client" />
      </div>
    </div>
  );
}
